var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHometickicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.625L13.125 18.125L19.375 11.875",
    stroke: "url(#paint0_linear_452_33)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7875 16.3475C3.58622 15.9266 3.48175 15.466 3.48175 14.9994C3.48175 14.5328 3.58622 14.0722 3.7875 13.6513C3.9625 13.2838 4.2625 12.9313 4.8625 12.2263C5.1025 11.945 5.2225 11.805 5.3225 11.655C5.55257 11.3119 5.71231 10.9265 5.7925 10.5213C5.8275 10.3438 5.8425 10.16 5.87125 9.79253C5.945 8.87003 5.98125 8.40878 6.1175 8.02253C6.2731 7.58276 6.52519 7.1834 6.85526 6.85376C7.18534 6.52412 7.58502 6.27255 8.025 6.11753C8.41 5.98128 8.87125 5.94378 9.795 5.87128C10.1625 5.84128 10.345 5.82628 10.5225 5.79128C10.9282 5.71125 11.314 5.5515 11.6575 5.32128C11.8075 5.22128 11.9475 5.10253 12.2275 4.86253C12.9325 4.26253 13.285 3.96253 13.6525 3.78628C14.0734 3.585 14.5341 3.48053 15.0006 3.48053C15.4672 3.48053 15.9278 3.585 16.3487 3.78628C16.7175 3.96128 17.07 4.26128 17.7737 4.86253C18.055 5.10253 18.195 5.22128 18.345 5.32128C18.6885 5.5515 19.0743 5.71125 19.48 5.79128C19.6562 5.82628 19.84 5.84128 20.2075 5.87128C21.1312 5.94378 21.5925 5.98128 21.9775 6.11753C22.4172 6.27271 22.8167 6.52435 23.1465 6.85398C23.4764 7.18361 23.7283 7.58289 23.8837 8.02253M6.1175 21.9763C6.27297 22.4159 6.52487 22.8152 6.85472 23.1448C7.18456 23.4745 7.584 23.7261 8.02375 23.8813C8.40875 24.0188 8.87 24.055 9.79375 24.1275C10.1612 24.1575 10.3437 24.1725 10.5212 24.2075C10.927 24.2876 11.3127 24.4473 11.6562 24.6775C11.8062 24.7775 11.9462 24.8963 12.2262 25.1363C12.9312 25.7363 13.2837 26.0363 13.6512 26.2125C14.0722 26.4138 14.5328 26.5183 14.9994 26.5183C15.4659 26.5183 15.9266 26.4138 16.3475 26.2125C16.7162 26.0375 17.0687 25.7375 17.7725 25.1363C17.9538 24.9723 18.1445 24.8191 18.3437 24.6775C18.6873 24.4473 19.073 24.2876 19.4787 24.2075C19.655 24.1725 19.8387 24.1575 20.2062 24.1275C21.13 24.055 21.5912 24.0175 21.9762 23.8813C22.416 23.7261 22.8154 23.4745 23.1453 23.1448C23.4751 22.8152 23.727 22.4159 23.8825 21.9763C24.0187 21.5913 24.055 21.1288 24.1287 20.2063C24.1575 19.8388 24.1725 19.655 24.2075 19.4775C24.2875 19.0725 24.4475 18.6863 24.6775 18.3438C24.7775 18.1938 24.8975 18.0538 25.1362 17.7725C25.7362 17.0675 26.0375 16.715 26.2137 16.3475C26.415 15.9266 26.5195 15.466 26.5195 14.9994C26.5195 14.5328 26.415 14.0722 26.2137 13.6513",
    stroke: "url(#paint1_linear_452_33)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_452_33",
    x1: 15,
    y1: 11.875,
    x2: 15,
    y2: 18.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_452_33",
    x1: 15.0006,
    y1: 3.48053,
    x2: 15.0006,
    y2: 26.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHometickicon);
export default __webpack_public_path__ + "static/media/hometickicon.e2a5c60a167c687b78e967c38d33ba3f.svg";
export { ForwardRef as ReactComponent };